import settings from '@/settings'

const pegarTodas = (headers, filtro) => {
  const keys = Object.keys(filtro)
  let url = `${settings.apetrusApi}/redes/ativas/?notPaged=true`
  for (let i = 0; i < keys.length; i++) {
    if (filtro[keys[i]] !== null && filtro[keys[i]] !== undefined && filtro[keys[i]] !== '') {
      url = `${url}&${keys[i]}=${filtro[keys[i]]}`
    }
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const get = (headers, data) => {
  let url = `${settings.apetrusApi}/redes/all/`
  if (data) {
    Object.keys(data).forEach((filter) => {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${filter}=${data[filter]}`
    })
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const atualizar = (headers, data) => {
  return fetch(`${settings.apetrusApi}/redes/atualizar/${data.id_rede}/`, {
    method: 'PUT',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const postosDaRede = (headers, data) => {
  return fetch(`${settings.apetrusApi}/redes/postosdarede/${data.id}/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const cadastrar = (headers, data) => {
  return fetch(`${settings.apetrusApi}/redes/cadastrar/`, {
    method: 'POST',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const postosSemRede = (headers, data) => {
  let url = `${settings.apetrusApi}/redes/semrede/`
  if (data) {
    Object.keys(data).forEach((filter) => {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${filter}=${data[filter]}`
    })
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const inserirEmRede = (headers, data) => {
  return fetch(`${settings.apetrusApi}/redes/inseriremrede/${data.id_rede}/`, {
    method: 'PUT',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const postoMatriz = (headers, data) => {
  return fetch(`${settings.apetrusApi}/redes/postomatriz/${data.id}/`, {
    method: 'PUT',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const detalhesRede = (headers, id) => {
  return fetch(`${settings.apetrusApi}/redes/${id}/detalhes/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const removerDaRede = (headers, data) => {
  return fetch(`${settings.apetrusApi}/redes/removerdarede/${data.id}/`, {
    method: 'PUT',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const deletarRede = (headers, id) => {
  return fetch(`${settings.apetrusApi}/redes/deletar/${id}/`, {
    method: 'DELETE',
    mode: 'cors',
    headers: headers
  })
}

export default {
  pegarTodas,
  get,
  atualizar,
  postosDaRede,
  deletarRede,
  removerDaRede,
  detalhesRede,
  postoMatriz,
  inserirEmRede,
  postosSemRede,
  cadastrar
}
